// CommunicatorPlugin/common/schemas/collections/callQueues.js
import { z } from "zod";

const CallQueueMemberSchema = z.object({
    extensionNumber: z.string().regex(/^\d{3,7}$/, "Must be a valid extension number"),
    // You could add other member-specific settings here, like level or position
});

const CallQueueSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().optional().describe("The subscription this queue belongs to."),
    serviceCode: z.string().optional().describe("The service code this queue belongs to."),
    name: z.string().min(3, "Queue name must be at least 3 characters").regex(/^[a-zA-Z0-9_-]+$/, "Name can only contain letters, numbers, underscore, and hyphen."),
    description: z.string().optional().nullable(),

    strategy: z.enum([
        "ring-all",
        "longest-idle-agent",
        "round-robin",
        "top-down",
        "agent-with-least-talk-time"
    ]).default("ring-all"),

    musicOnHold: z.string().optional().nullable().describe("Path to music on hold file or sound string."),
    timeout: z.number().int().min(10).default(300).describe("Max time in seconds a caller waits in the queue."),

    // This flexible schema is the key to solving the client-side validation issue.
    members: z.array(z.string()).optional().default([]),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default CallQueueSchema;